
import { StyleSheet } from "aphrodite";

export const styles = StyleSheet.create({

  imageiconsMenu: {
    width: "25px"
  },
  mainGrid: {
    padding: "2em 5em",
    margin: "0px",
    //minHeight: "90vh",
    minHeight: "calc(98vh - 120px)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    borderBottom: "2px solid #76787a",
    paddingBottom: "10px",
    margin: "10px 0px 10px 0px",
    color: "black",
    fontSize: "18px",
  },
})
